import React from 'react';

const RouterContext = React.createContext({
  location: null,
  matches: null,
});

export default RouterContext;
